import React from "react";
import { Button, Modal } from "semantic-ui-react";
import ProgressLoader from "../../Common/ProgressLoader";

interface EnableFeenavigatorProps {
  loading: boolean;
  selectedUser: any;
  openEnableFeenavigatorModal: boolean;
  handleCancel: () => void;
  updateFeenavigatorEnabledStatus: () => Promise<void>;
  feenavigatorEnabled: boolean;
}

const EnableFeenavigatorModal = (props: EnableFeenavigatorProps) => {
  const {
    handleCancel,
    updateFeenavigatorEnabledStatus,
    openEnableFeenavigatorModal,
    selectedUser,
    feenavigatorEnabled,
    loading,
  } = props;

  return (
    <Modal
      centered
      open={openEnableFeenavigatorModal}
      onClose={handleCancel}
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Modal.Content>
        <div className="close-button">
          <button
            className="email-activity-close-button"
            onClick={handleCancel}
          >
            X
          </button>
        </div>
        <ProgressLoader loading={loading} size="small" />
        <div className="word-wrap">
        {`Are you sure you want to ${
          feenavigatorEnabled ? "enable" : "disable"
        } Fee Navigator for ${selectedUser.user_name.first_name} ${selectedUser.user_name.last_name} ( ID - ${selectedUser.user_id} )?`}
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCancel}>CANCEL</Button>
        <Button onClick={updateFeenavigatorEnabledStatus} color="blue">
          YES
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EnableFeenavigatorModal;
